// Runtime-constant values only. Data entities (hotels, openings, news) are fetched from backend.

export const VALUES = [
  {
    title: "Efficienza",
    text: "Ogni progetto è costruito per durare, funzionare e crescere. Nessuna scelta decorativa, nessun compromesso strutturale.",
  },
  {
    title: "Controllo diretto",
    text: "Niente franchising, niente gestione in outsourcing. Seguiamo in prima persona ogni fase della catena del valore.",
  },
  {
    title: "Visione di lungo periodo",
    text: "Pensiamo come proprietari, operiamo come gestori. Il rendimento si costruisce nel tempo, non nella singola stagione.",
  },
  {
    title: "Qualità urbana",
    text: "I nostri hotel contribuiscono alla rigenerazione della città. Restituiamo valore al quartiere, al tessuto sociale, alla skyline.",
  },
];

export const SPACES = [
  {
    key: "meeting",
    label: "Sale Meeting",
    title: "Modularità, tecnologia, atmosfera.",
    text: "Sale meeting adatte a ogni tipo di riunione, con partizioni mobili, tecnologia AV integrata e lounge di prossimità.",
    image:
      "",
  },
  {
    key: "lounge",
    label: "Lounge",
    title: "JLounge, sky-bar, cocktail d'autore.",
    text: "Dalla lounge riservata del J24 alla terrazza del Glam: ambienti dove lavoro, incontro e relax si intrecciano.",
    image:
      "",
  },
  {
    key: "events",
    label: "Eventi",
    title: "Cene private, lanci, celebrazioni.",
    text: "Spazi versatili per eventi corporate, lanci prodotto e celebrazioni private. Staff operativo dedicato.",
    image:
      "",
  },
];

export const STATS = {
  hotels: 15,
  rooms: 2053,
  pipelineHotels: 5,
  pipelineRooms: 674,
  foundedYear: 2014,
};

// Detect legacy WordPress image URLs that became dead after the DNS switch
// from the old investhospitality.it WordPress site to the new Emergent build.
// These return HTML (the SPA fallback) instead of the actual image, which
// causes the browser to refuse them with ORB / MIME-mismatch errors —
// visible as black/empty image areas, especially on mobile Chrome.
export function isDeadLegacyUrl(url) {
  if (!url) return true;
  return /investhospitality\.it\/wp-content\/(uploads|cache)\//.test(url);
}

// Resolve backend-served image paths to absolute URLs.
// Dead legacy URLs are returned as "" so the UI shows the elegant fallback
// (brass gradient + hotel logo) instead of a broken black box.
export function resolveImage(url) {
  if (!url) return "";
  if (isDeadLegacyUrl(url)) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
}

// Whether a logo file needs to be inverted to show white-on-dark.
// NOTE: files with suffix "-nero" (Italian naming from original site) are
// ALREADY white-on-black raster exports, so they must NOT be inverted.
// Only the older vectorial "*-dark" / "*-black" exports (dark strokes on
// transparent bg) need the invert filter to appear white on dark surfaces.
export function needsInvert(url) {
  if (!url) return false;
  if (/nero/i.test(url)) return false;
  return /black|dark/i.test(url);
}
